import * as type from 'constants/action_types/review_automation'
import { t } from 'services/i18n'
import {
  REVIEW_AUTOMATION_ACTIVATED,
  REVIEW_REQUEST_DELAY_UPDATED
} from 'constants/activation_points/review_automation'
import { SET_AMAZON_SELLER_ACCOUNT_SELECTOR_DATA } from 'constants/action_types/amazon_seller_accounts'
import Api from 'services/api/review_automation'
import { sendSegmentTrackEvent, safeSegmentCall } from 'services/segment'
import { setGlobalModal } from 'actions/index'
import { createNotification } from './notifications'

export const toggleReviewAutomation = reviewAutomationEnabled => async (
  dispatch,
  getState
) => {
  const {
    amazonSellerAccounts: {
      amazonSellerAccountSelector,
      amazonSellerAccountSelector: {
        selectedAccount,
        selectedCountry: { marketplace_id, country_code }
      }
    }
  } = getState()

  const data = {
    amazon_seller_account_id: selectedAccount.id,
    review_automation_enabled: reviewAutomationEnabled,
    amazon_marketplace: country_code
  }

  dispatch({
    type: type.PENDING_REVIEW_AUTOMATION_ACTION,
    payload: 'toggle'
  })

  const res = await Api.updateMarketplace(marketplace_id, data)

  dispatch({
    type: type.COMPLETED_REVIEW_AUTOMATION_ACTION,
    payload: 'toggle'
  })

  if (res.ok) {
    dispatch({
      type: SET_AMAZON_SELLER_ACCOUNT_SELECTOR_DATA,
      payload: {
        ...amazonSellerAccountSelector,
        selectedCountry: {
          ...amazonSellerAccountSelector.selectedCountry,
          review_automation_enabled: reviewAutomationEnabled
        }
      }
    })
    if (reviewAutomationEnabled) {
      safeSegmentCall(() => {
        sendSegmentTrackEvent(REVIEW_AUTOMATION_ACTIVATED)
      })
    }
  } else {
    dispatch(
      createNotification({
        message: res.error,
        level: 'error',
        title: 'Toggle Review Automation Error'
      })
    )
  }
}

export const updateRequestDelay = requestDelay => async (
  dispatch,
  getState
) => {
  const {
    amazonSellerAccounts: {
      amazonSellerAccountSelector,
      amazonSellerAccountSelector: {
        selectedAccount,
        selectedCountry: { marketplace_id, country_code }
      }
    }
  } = getState()

  const data = {
    amazon_seller_account_id: selectedAccount.id,
    review_request_delay: requestDelay,
    amazon_marketplace: country_code
  }

  dispatch({
    type: type.PENDING_REVIEW_AUTOMATION_ACTION,
    payload: 'request_delay'
  })

  const res = await Api.updateMarketplace(marketplace_id, data)

  dispatch({
    type: type.COMPLETED_REVIEW_AUTOMATION_ACTION,
    payload: 'request_delay'
  })

  if (res.ok) {
    dispatch({
      type: SET_AMAZON_SELLER_ACCOUNT_SELECTOR_DATA,
      payload: {
        ...amazonSellerAccountSelector,
        selectedCountry: {
          ...amazonSellerAccountSelector.selectedCountry,
          review_request_delay: requestDelay
        }
      }
    })
    safeSegmentCall(() => {
      sendSegmentTrackEvent(REVIEW_REQUEST_DELAY_UPDATED)
    })
    dispatch(
      createNotification({
        message: res.message,
        level: 'success',
        title: t(
          'review_automation:ReviewAutomationSettings.successNotification',
          'Successfully Updated Request Delay'
        )
      })
    )
    dispatch(setGlobalModal(null))
  } else {
    dispatch(
      createNotification({
        message: res.error,
        level: 'error',
        title: t(
          'review_automation:ReviewAutomationSettings.errorNotification',
          'Update Review Request Error'
        )
      })
    )
  }
}
